import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';

import {Flex} from "reflexbox";
import CopyItem from "../components/common/CopyItem";
import Typography from "@mui/material/Typography";
import {useDispatch, useSelector} from "react-redux";
import Box from "@mui/material/Box";
import TeamNameDisplayAndEdit from "../components/gameSetupAndLobby/TeamNameDisplayAndEdit";
import PersonalProfileDisplayAndEdit from "../components/PersonalProfileDisplayAndEdit";
import {leaveTeam, writeCurrentTeamIdData, writeUserIntent} from "../helpers/dbFunctions";
import { updateUserIntent } from "../redux/userSlice";
import { createAlert } from "../redux/uiSlice";
import Avatar from "@mui/material/Avatar";
import JoinTeamDialog from "../components/gameSetupAndLobby/JoinTeamDialog";
import {Add} from "@mui/icons-material";
import AlertDialog from "../components/common/AlertDialog";
import TeamMemberNamesList from "../components/gameSetupAndLobby/TeamMemberNamesList";
import {messageType} from "../components/common/RequestAlertBar";

const TeamsJoinOrHost = () => {
  const dispatch = useDispatch();

  const { uid, userIntent: userIntentFromRedux } = useSelector((state) => state.user);
  const { currentTeamId, teamDetails } = useSelector((state) => state.team);
  const { teammateInfo } = teamDetails || {};

  const teamLength = teammateInfo ? Object.keys(teammateInfo).length : '';

  const [localTeamId, setLocalTeamId] = useState(currentTeamId || '');
  const [userIntent, setUserIntent] = useState(userIntentFromRedux || '');
  const [editNameDialog, setEditNameDialog] = useState(false);
  const [joinTeamDialog, setJoinTeamDialog] = useState(false);
  const [leaveTeamDialog, setLeaveTeamDialog] = useState(false);
  const [switchUserIntentToHostDialog, setSwitchUserIntentToHostDialog] = useState(false);
  const[youAreHostingDialog, setYouAreHostingDialog] = useState(false);
  const [switchUserIntentToSoloDialog, setSwitchUserIntentToSoloDialog] = useState(false);
  const [localStateTeammateInfo, setLocalStateTeammateInfo] = useState(teammateInfo);

  const userIntentOptions = {
    JOIN: 'JOIN',
    HOST: 'HOST',
    SOLO: 'SOLO'
  };
  useEffect(()=>{
    const newTeamMembers = teammateInfo;
    const newTeamMembersLength = teamLength || 0;
    const oldTeamMembersLength = localStateTeammateInfo && Object.keys(localStateTeammateInfo)?.length || 0;
    // austin, why is it that newTeamMembers will go to 0 / undefined?
    if(newTeamMembersLength>0 && oldTeamMembersLength>0) {
      if(newTeamMembersLength > oldTeamMembersLength) {
        dispatch(createAlert({
          type: messageType.success,
          message: 'Team member joined!',
        }));
      } else if ( newTeamMembersLength < oldTeamMembersLength) {
        dispatch(createAlert({
          type: messageType.warning,
          message: 'Team member left!',
        }));
      }
    }
    newTeamMembersLength>0 && setLocalStateTeammateInfo(newTeamMembers)

  },[teammateInfo]);


  const handleGenerateCode = () => {
    //note that this function is outside of handleHostTeamClick in case we want a "generate another code" button
    const code = generateRandomCode();
    //need to add a check that this teamID doesn't currently already exist. Should be able to use await getMemberIdsForGivenTeamId(joinCode);
    setLocalTeamId(code);
    writeCurrentTeamIdData(uid, code);
  };

  const handleHostOrSoloClick = (type) => async () => {
    //if user is switching from one thing to another (e.g. hosting to solo play, joined a team to hosting, etc): check if team members exists on current team  if yes, leave team; if no, they can stay
    if (
      !!teamDetails?.memberIds &&
      teamDetails?.memberIds.length > 1
    ) {
      await handleLeaveTeam();
      setLocalTeamId('');
      handleGenerateCode();
    } else if (!localTeamId) {
      handleGenerateCode();
    }
    writeUserIntent(uid, type);
    dispatch(updateUserIntent(type));
    setUserIntent(type);
    type===userIntentOptions.HOST && setYouAreHostingDialog(true);
  };

  const handleJoinTeamClick = () => {
    setJoinTeamDialog(true);
  };

  const generateRandomCode = () => {
    const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    //note that O, I, 0, 1 because they are hard to tell apart for some people
    let code = '';
    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      code += characters.charAt(randomIndex);
    }
    return code;
  };

  const handleSwitchUserIntent = (intent) => {
    //if a user's intent is already selected, launch a popup
    if (userIntent) {
      if (userIntent === intent) {
        //don't do anything if the user is staying in the same intent
        return;
      }
      intent === userIntentOptions.HOST && setSwitchUserIntentToHostDialog(true);
      intent === userIntentOptions.SOLO && setSwitchUserIntentToSoloDialog(true);
    } else {
      handleHostOrSoloClick(intent)();
    }
  };

  const handleLeaveTeam = () => {
    return new Promise((resolve, reject) => {
      leaveTeam(teamDetails.memberIds, currentTeamId, uid);
      writeCurrentTeamIdData(uid, '', []);
      setLocalTeamId('');
      writeUserIntent(uid, '');
      setUserIntent('');
      resolve("Data has been fetched!");
    })
  };

  return (
    <>
      <Flex style={{width: '100%'}}>
        <Button style={{width: '100%', borderRadius: (userIntent === userIntentOptions.JOIN) ? '5px' : 0, border: '0px', borderRight: userIntent !== userIntentOptions.HOST && '1px solid'}} variant={userIntent === userIntentOptions.JOIN ? 'contained' : 'outlined'}
                color="primary" onClick={handleJoinTeamClick}>
          Join Team
        </Button>
        <Button style={{width: '100%', borderRadius: userIntent === userIntentOptions.HOST ? '5px' : 0, border: '0px', borderRight: '1px solid'}} variant={userIntent === userIntentOptions.HOST ? 'contained' : 'outlined'}
                color="primary" onClick={() => handleSwitchUserIntent(userIntentOptions.HOST)}>
          Host Team
        </Button>
        <Button style={{width: '100%', borderRadius: '5px', border: '0px',}} variant={userIntent === userIntentOptions.SOLO ? 'contained' : 'outlined'}
                color="primary" onClick={() => handleSwitchUserIntent(userIntentOptions.SOLO)}>
          Play Solo
        </Button>
      </Flex>

      <AlertDialog open={switchUserIntentToHostDialog}
                   close={() => setSwitchUserIntentToHostDialog(false)}
                   continue={
                     handleHostOrSoloClick(userIntentOptions.HOST)
                   }
                   title={'Host a team'}
                   rightButtonText={'Continue'}
                   body={'Are you sure you want to switch from your current selection and host a team?'}/>
      <AlertDialog open={youAreHostingDialog}
                   close={() => setYouAreHostingDialog(false)}
                   title={"You're hosting!"}
                   rightButtonText={'Ok'}
                   disableCancel
                   body={<Flex style={{flexDirection: 'column'}}>
                     <Typography variant={'caption'} style={{paddingLeft: '8px', display: 'flex', alignItems: 'center'}}> Invite
                       others to join with code: </Typography>
                     <Flex>
                       <Typography style={{padding: '0 8px', fontWeight: 'bold'}}>{currentTeamId}</Typography>
                       <CopyItem thingToCopy={currentTeamId}/>
                     </Flex>
                   </Flex>}
      />
      <AlertDialog open={switchUserIntentToSoloDialog}
                   close={() => setSwitchUserIntentToSoloDialog(false)}
                   continue={
                     handleHostOrSoloClick(userIntentOptions.SOLO)
                   }
                   title={'Play Solo'}
                   rightButtonText={'Continue'}
                   body={'Are you sure you want to leave your current team and play solo?'}/>

      {userIntent && teammateInfo  && (<>
        <Typography style={{fontWeight: 'bold', paddingTop: '12px'}}> Team members ({teamLength})</Typography>
        {<TeamMemberNamesList teammateInfo={teammateInfo} uid={uid} editName={() => setEditNameDialog(true)}/>}
        {userIntent !== userIntentOptions.SOLO &&
        <Flex id={'add team member'} style={{paddingTop: '8px', alignItems: 'center'}}>
          <Avatar>
            <Add/>
          </Avatar>
          <Flex style={{flexDirection: 'column'}}>
            <Typography variant={'caption'} style={{paddingLeft: '8px', display: 'flex', alignItems: 'center'}}> Invite
              others to join with code: </Typography>
            <Flex>
              <Typography style={{padding: '0 8px', fontWeight: 'bold'}}>{currentTeamId}</Typography>
              <CopyItem thingToCopy={currentTeamId}/>
            </Flex>
          </Flex>
        </Flex>}
        <Box style={{margin: '16px 0'}}>
          <TeamNameDisplayAndEdit/>
        </Box>
        {userIntent !== userIntentOptions.SOLO &&
        <Button id={'leave team button'} color={'secondary'} style={{paddingLeft: 0, width: 'fit-content'}}
                onClick={() => setLeaveTeamDialog(true)}
        > Leave Team</Button>}
        <AlertDialog open={leaveTeamDialog}
                     close={() => setLeaveTeamDialog(false)}
                     continue={() => {
                       handleLeaveTeam();
                     }}
                     title={'Leave team'}
                     rightButtonText={'Leave'}
                     body={'Are you sure you want to leave?'}/>
      </>)}

      <PersonalProfileDisplayAndEdit open={editNameDialog} close={() => setEditNameDialog(false)}/>
      <JoinTeamDialog open={joinTeamDialog} close={() => setJoinTeamDialog(false)}
                      setIntentIfSuccess={() => {
                        writeUserIntent(uid, userIntentOptions.JOIN);
                        setUserIntent(userIntentOptions.JOIN);
                        setJoinTeamDialog(false)
                      }
                      }/>
    </>
  );
};

export default TeamsJoinOrHost;